import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AffordabilityFormComponent, ResultsComponent } from './pages';

const routes: Routes = [
  {
    path: '',
    component: AffordabilityFormComponent,
  },
  {
    path: 'results',
    component: ResultsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppRoutingModule { }
